"use client";

import React from "react";
import TryToolButton from "../../button/TryToolButton";

interface CTASectionProps {
  title: string;
  description: string;
  buttonText: string;
}

export default function CTASection({
  title,
  description,
  buttonText,
}: CTASectionProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center bg-[#ecf2ff] py-12 sm:py-16 md:py-20">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-8 px-4 sm:gap-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-start gap-4 sm:gap-5">
          <h2 className="text-center text-2xl font-semibold text-blue-600 sm:text-3xl md:text-4xl">
            {title}
          </h2>
          <p className="max-w-prose text-center text-base font-normal leading-7 text-[#171618] sm:text-lg">
            {description}
          </p>
        </div>
        <div className="flex items-center justify-center">
          <TryToolButton buttonText={buttonText} />
        </div>
      </div>
    </div>
  );
}
